import axios from 'axios';
import { handlePromise, makeFailure, makeSuccess } from "../infra/utils";
function getChannelFromWindow(key) {
  const channel = window[key];
  return typeof channel === 'string' ? channel : '';
}
async function sendSlackMessage(url, text) {
  if (url && text) {
    return handlePromise(axios.post(url, JSON.stringify({
      text
    }), {
      withCredentials: false
    }));
  }
  return makeFailure('No URL');
}
export let SlackUserGroups = /*#__PURE__*/function (SlackUserGroups) {
  SlackUserGroups["ProductTeam"] = "<!subteam^S04FHKU667K|product-team>";
  return SlackUserGroups;
}({});
const mockSendSlackMessage = async () => makeSuccess({
  data: {}
});
export const mockSlackClient = {
  sendCsNotificationsMessage: mockSendSlackMessage,
  sendRoleIntentLoggerMessage: mockSendSlackMessage,
  sendPayoutValidationMessage: mockSendSlackMessage
};
export const slackClient = {
  sendCsNotificationsMessage(text) {
    const csNotificationsChannel = getChannelFromWindow('slackCsChannelUrl');
    return sendSlackMessage(csNotificationsChannel, text);
  },
  sendRoleIntentLoggerMessage(text) {
    const roleIntentLoggerChannel = getChannelFromWindow('slackRoleIntentLoggerChannelUrl');
    return sendSlackMessage(roleIntentLoggerChannel, text);
  },
  sendPayoutValidationMessage(text) {
    const payoutsChannel = getChannelFromWindow('slackPayoutsChannelUrl');
    return sendSlackMessage(payoutsChannel, text);
  }
};